// @flow

import styled from 'styled-components';
import StyledRow from '../row/row.styled';

import type { Theme } from '../../types';

type Props = {
  sticky: boolean,
};

const ProgressRow = styled<typeof StyledRow, Theme, Props>(StyledRow)`
  background-color: ${props => props.theme.progressRow.backgroundColor};
  border: 1px solid ${props => props.theme.progressRow.borderColor};
  line-height: 2rem;
  top: -2px;
  box-shadow: ${props => (props.sticky ? '0 3px 3px 0 rgba(0, 0, 0, 0.3)' : '0')};
`;

const ProgressContainer = styled<any, Theme>('section')`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
  width: 100%;
`;

export {
  ProgressRow,
  ProgressContainer,
};

export default ProgressRow;
